import axios from 'axios'
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'

export function useClients({
    onArchived = () => {},
    onRestored = () => {},
    onError = () => {},
}) {
    const $toast = useToast()

    const archiving = ref(false)
    const restoring = ref(false)

    const archiveClient = async (id) => {
        try {
            archiving.value = true
            await axios.delete(`/api/clients/${id}`)
            onArchived()
        } catch (error) {
            onError(error)
        } finally {
            archiving.value = false
        }
    }

    const restoreClient = async (id) => {
        try {
            restoring.value = true
            await axios.post(`/api/clients/${id}/restore`)
            $toast.success('Client restauré', {
                position: 'top',
                duration: 5000,
                dismissible: true,
                pauseOnHover: true,
            })
            onRestored()
        } catch (error) {
            onError(error)
        } finally {
            restoring.value = false
        }
    }

    return {
        archiving,
        restoring,
        archiveClient,
        restoreClient,
    }
}
